import { getContext } from "svelte";

type RouterContext = {
    path: string
}


export function useLocation() {
    let location = getContext<RouterContext>('location');

    function navigate(to: string) {
        window.history.pushState({}, '', to);
        location.path = to;
    }


    return {
        navigate, location
    }
}